import { render } from "./WelcomePage.vue?vue&type=template&id=1e4891fc&ts=true"
import script from "./WelcomePage.vue?vue&type=script&lang=ts"
export * from "./WelcomePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/WelcomePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e4891fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e4891fc', __exports__)) {
    api.reload('1e4891fc', __exports__)
  }
  
  module.hot.accept("./WelcomePage.vue?vue&type=template&id=1e4891fc&ts=true", () => {
    api.rerender('1e4891fc', render)
  })

}


export default __exports__